export default __webpack_public_path__ + "static/media/1924.741553fd.png";